import Vue from 'vue';
import Router from 'vue-router';
import store from '../store/index';

Vue.use(Router);

import BaseRoutes from './base';

export default new Router({
	routes: [
		...BaseRoutes,
	]
});
